import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const useNavigationService = () => {
  const navigate = useNavigate();
  const lang = navigator.language.startsWith("fr") ? "fr" : "en";

  const navigateToDashboard = (domain) => {
    localStorage.setItem("selectedDomain", JSON.stringify(domain));

    if (domain.role === 'manager') {
      toast.success(
        lang === "fr"
          ? `Bienvenue, Manager de ${domain.name} ! `
          : `Welcome, Manager of ${domain.name}! `
      );
      window.location.href = `/page/app/Component/admin/admin_trade_vault`;
    } else {
      toast.success(
        lang === "fr"
          ? `Bienvenue, Client de ${domain.name} ! `
          : `Welcome, Client of ${domain.name}! `
      );
      window.location.href = '/page/app/customer/dashboard_customer_trade_vault';
    }
  };

  return { navigateToDashboard };
};

export default useNavigationService;